//@flow
import CreditCardsStore from './creditCardsStoreClass';

export default new CreditCardsStore();
